export { PlusCircle as default } from './PlusCircle';
